import HTML from "@client/controls/HTML/component";
import * as React from "react";

export interface HeadingProps {
  className?: string;
  content?: string;
  level: string;
  style?: React.CSSProperties;
}

const Heading = React.memo((props: HeadingProps) => (
  <HTML className={props.className} style={props.style ?? undefined} tag={props.level} html={props.content} />
));

export default Heading;
